import { CommonOrderReturn } from './ComonOrderReturn';
import { LazadaOrderReturn } from './LazadaOrderReturn';

interface OrderReturnProps {
  storeId: string;
  order: Conversation.Trade.Vo;
  onUpdate: () => void;
}

export const OrderReturn = (props: OrderReturnProps) => {
  const { order } = props;
  const { platform } = order;

  if (platform === 'lazada') {
    return <LazadaOrderReturn {...props} />;
  }

  return <CommonOrderReturn {...props} />;
};
